import { IBag } from '@@/bags/ts';
import { AgricultureDefaultParametersNames } from '@@/agriculture/ts';
import { Humidity, Temperature, Weight } from '@ui/icons';
import { DiContainer } from '@@/di/di-container';
import { AgricultureParametersService } from '@@/agriculture/services/agriculture-parameters.service';

const agricultureParametersService = DiContainer.get(AgricultureParametersService);

export function useBagMainParametersHook(bag: IBag): Array<{
  label: JSX.Element;
  value: string;
}> {
  const humidityParameter = bag.values.find(
    (item) => item.name === AgricultureDefaultParametersNames.Humidity,
  );
  const humidityLvlColor = agricultureParametersService.getHumidityColor(
    humidityParameter?.value ?? null,
  ) as string;

  const temperatureParameter = bag.values.find(
    (item) => item.name === AgricultureDefaultParametersNames.Temperature,
  );
  const temperatureLvlColor = agricultureParametersService.getTemperatureColor(
    temperatureParameter?.value ?? null,
  );

  return [
    {
      label: <Humidity fill={humidityLvlColor} />,
      value: `${humidityParameter?.value ?? ''}${humidityParameter?.units}`,
    },
    {
      label: <Temperature fill={temperatureLvlColor} />,
      value: `${temperatureParameter?.value ?? '-'}${
        temperatureParameter?.units ?? ''
      }`,
    },
    {
      label: <Weight />,
      value: `${bag.weight}т`,
    },
  ];
}
